import { render, staticRenderFns } from "./AgencyDocumentsView.vue?vue&type=template&id=d08da564&scoped=true&"
import script from "./AgencyDocumentsView.vue?vue&type=script&lang=js&"
export * from "./AgencyDocumentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08da564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
